<template>
  <div>
    <!-- PR维护 -->
    <ContentHeader />
    <div class="content">
      <div class="main">
        <div class="title">PO列表</div>
        <div class="card_box" v-loading="listLoading">
          <div v-if="poList.length > 0">
            <el-card class="item-list" v-for="item in poList" :key="item.poNumber + item.brandCode">
              <div class="item_list_top">
                <div class="top_title_box">
                  <div class="top_left">PO编号：{{ item.poNumber }}</div>
                  <div class="top_center">PR编号：{{ item.prNumber }}</div>
                </div>
                <div class="right_btn_box">
                  <div class="right_btn" @click="openDialog(item,'01')">查看明细</div>
                  <div class="right_btn" @click="openDialog(item,'02')" v-if="canClosePo(item)">关闭PO</div>
                </div>
              </div>
              <div class="item_list_bottom">
                <div class="bottom_left flex">
                  <div class="first">
                    <img class="img" src="../../assets/images/active-img.png" alt="" />
                    <div class="text">供应商：{{ item.vendorName }}({{ item.vendorCode }})</div>
                  </div>
                  <div class="first">
                    <div class="text">总金额：{{ formatPrice(item.poAmount) }} 元</div>
                  </div>
                  <div class="first">
                    <div class="text">PO状态：{{poStatusMap[item.poStatus]}}</div>
                  </div>
                </div>
              </div>
            </el-card>

            <div class="content-pagination">
              <el-pagination background layout="total, prev, pager, next" :total="total" :page-sizes="[10, 20, 30, 40]"
                :current-page="queryParams.page" :page-size="queryParams.pageSize" @current-change="handleCurrentChange"
                @size-change="handleSizeChange" />
            </div>
          </div>
          <div v-else class="no_data">暂无数据</div>
        </div>
        <el-dialog class="detail-dialog" :title="viewTypeMap[viewType]" top="5vh" :visible.sync="dialogVisible"
          :close-on-click-modal="false">
          <div v-loading="dialogLoading">
            <el-table ref="poDetailTable" :data="poDetailList" style="width: 100%" :header-cell-style="{
                background: '#E8E8E8'
              }">
              <el-table-column align="center" v-if="viewType === '02'" :key="tableKey">
                <template slot="header">
                  <el-checkbox v-model="poChecked" @change="val => dialogSelectChange(val, 'checkAll')"></el-checkbox>
                </template>
                <template slot-scope="scope">
                  <el-checkbox v-model="scope.row.checked"  :disabled="scope.row.detailStatus === 0"
                    @change="val => dialogSelectChange(val, 'checked')"></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column prop="rowNumber" label="行项目号" align="center">
              </el-table-column>
              <el-table-column prop="itemCode" label="物料编码" align="center">
              </el-table-column>
              <el-table-column prop="itemName" label="物料名称" align="center">
              </el-table-column>
              <el-table-column prop="itemAmount" label="总金额(元)" align="center">
                <template slot-scope="scope">
                  {{ scope.row.itemAmount | numberToCurrency(true) }}
                </template>
              </el-table-column>
              <el-table-column prop="grAmount" label="已收货金额(元)" align="center">
                <template slot-scope="scope">
                  {{ scope.row.grAmount | numberToCurrency(true) }}
                </template>
              </el-table-column>
              <el-table-column prop="" label="剩余金额(元)" align="center">
                <template slot-scope="scope">
                  {{ scope.row.itemAmount - scope.row.grAmount | numberToCurrency(true) }}
                </template>
              </el-table-column>
              <el-table-column prop="detailStatus" label="状态" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.detailStatus === 1">正常</span>
                  <span v-if="scope.row.detailStatus === 0">关闭</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div slot="footer" v-if="viewType === '02'">
            <el-button class="btn_bg_white normal_btn" @click="dialogVisible = false">取消</el-button>
            <el-button class="btn_bg_red normal_btn" @click="handleClosePo" >确定</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ContentHeader from "@/components/content-header";
import gameplanApi from "@/api/gameplan";
export default {
  name: "PO-maintain",
  components: {
    ContentHeader,
  },
  data() {
    return {
      queryParams: {
        page: 1,
        pageSize: 10,
        prNumber: ''
      },
      total: 0,
      poForm: {
        poNumber: '',
        prNumber: "",
        vendorName: "",
        poStatus: "",
        poAmount: "",
        vendorCode: "",
      },
      params: {
        poNumber: '',
        prNumber: "",
        vendorName: "",
        poStatus: "",
        poAmount: "",
        vendorCode: "",
      },
      poList: [],
      poStatusMap: {
        1: "有效",
        2: "无效",
      },

      dialogVisible: false,
      dialogLoading: false,
      poDetailList: [],
      multipleSelection: [],
      poChecked: false,
      viewTypeMap:{
        '01':'查看明细',
        '02':'关闭PO'
      },
      viewType:'',
      tableKey:1
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  created() {
    this.queryParams.prNumber = this.$route.query.prNumber
    this.getGameplanPoList();
  },
  methods: {
    async getGameplanPoList() {
      this.listLoading = true;
      const { data } = await gameplanApi.getGameplanPoList(this.queryParams);
      this.listLoading = false;
      if (data.resultCode === "0") {
        this.poList = data.resultData?.poList || [];
        this.total = data.resultData.pageInfo.totalCounts;
      }
    },
    // 关闭PO
    handleClosePo() {
      this.$confirm('是否确定关闭该PO明细行?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        confirmButtonClass: 'btn-red',
        type: 'warning'
      }).then(async () => {
        const params = {
          poNumber: this.poDetailList[0] && this.poDetailList[0].poNumber,
          poDetailList: this.multipleSelection
        }
        this.dialogLoading = true
        const { data } = await gameplanApi.getGameplanPrimeClosePo(params);
        if (data.resultCode === "0") {
          this.dialogVisible = false
          this.$message.success("关闭成功！");
          this.getGameplanPoList()
          this.resetForm()
        } else {
          this.$message.error(data.resultMsg);
        }
        this.dialogLoading = false
      }).catch(() => {
      });
    },
    resetForm() {
      this.$refs.poForm.resetFields();
    },
    canClosePo(item){
      return item.poStatus === 1
    },
    formatPrice(price) {
      return String(price).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    // handleDialogClose() {
    //   this.dialogVisible = false
    // },
    handleCurrentChange(val) {
      this.queryParams.page = val;
      this.getGameplanPoList();
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.getGameplanPoList();
    },
    // 打开PO明细列
    async openDialog(item,viewType) {
      this.viewType = viewType
      this.poDetailList = []
      this.multipleSelection = []
      this.dialogVisible = true
      this.dialogLoading = true
      const { data } = await gameplanApi.getPoInfo({
        poNumber: item.poNumber
      })
      if (data.resultCode === "0") {
        const gpPoDTO = data.resultData.gpPoDTO || {}
        this.poDetailList = gpPoDTO.poDetailList || []
        if(this.viewType === '02'){
          // 关闭PO，只展示未关闭明细行
          this.poDetailList = this.poDetailList.filter(item =>{
            return item.detailStatus === 1
          })
        }
        
      }
      this.dialogLoading = false
    },
    // 明细列选中变化
    dialogSelectChange(val, type) {
      console.log(type ,this.poDetailList)
      if (type === 'checkAll') {
        // 全选
            this.poDetailList.map(item => {
            if (item.detailStatus === 1) {
              item.checked = val
            }
          })
      } else {
        // 表格多选框 ,非全选
        // 可选明细行数量
        const count = this.poDetailList.filter(item => {
          return item.detailStatus === 1
        })
        // 勾选明细行数量
        const checkedCount = this.poDetailList.filter(item => {
          return item.checked === true
        })
        // 判断全选状态
        this.poChecked = (count != 0 && count.length === checkedCount.length )
        // console.log(count, checkedCount)
      }
      // 勾选明细行列表
      this.multipleSelection = this.poDetailList.filter(item => {
        return item.detailStatus === 1 && item.checked === true
      })
      this.tableKey = Math.random()
      console.log(this.poChecked)
    }
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-card__body {
  padding: 0;
}

::v-deep .el-card {
  border: 0;
}

.header {
  height: 100px;
  background: url("../../assets/images/banner-menu.jpg") center no-repeat;
  background-size: cover;
}

.content {
  width: 100%;
  line-height: 20px;
  background-color: #f3f5f9;
  text-align: center;
  font-family: SourceHanSansSC-regular;

  .main {
    width: 894px;
    min-height: calc(100vh - 400px);
    margin: 0 auto;
    margin-bottom: 80px;

    // background-color: aqua;
    .title {
      font-weight: 600;
      text-align: left;
      margin: 35px 0 10px 0;
      font-size: 18px;
      color: #101010;
    }

    .box-card {
      width: 894px;
      line-height: 20px;
      border-radius: 8px;
      font-size: 14px;

      .form-box {
        display: flex;
        flex-wrap: wrap;
        padding-left: 10px;
        margin-top: 20px;

        .item-lable {
          // border: 1px solid ;
          margin-right: 20px;
          margin-top: 5px;
          height: 30px;

          .item {
            width: 145px;
            height: 30px;
            border-radius: 4px;
            text-align: left;
          }
        }
      }

      .btn {
        margin: 20px 0;
      }
    }

    .card_box {
      min-height: 200px;
    }

    .item-list {
      width: 894px;
      border-radius: 8px;
      text-align: center;
      margin-bottom: 25px;

      .item_list_top {
        width: 100%;
        //height: 58px;
        background-color: #ffd6e8;
        display: flex;
        justify-content: space-between;
        padding: 13px 0;

        .top_title_box {
          display: flex;
          align-items: center;

          .top_left {
            // width: 172px;
            font-weight: 600;
            color: #cd1231;
            font-size: 16px;
            text-align: left;
            margin: 0 40px 0 20px;
            min-width: 180px;
          }

          .top_center {
            // width: 174px;
            font-size: 13px;
            font-weight: bold;
          }
        }

        .right_btn_box {
          display: flex;
        }

        .right_btn {
          padding: 3px 12px;
          font-size: 12px;
          border-radius: 4px;
          text-align: center;
          background-color: #ffffff;
          border: 1px solid #2185d0;
          color: #2185d0;
          margin-right: 20px;
          cursor: pointer;
        }

        .right_link {
          color: #2185d0;
          padding: 5px 20px 5px 0;
          text-align: center;
          font-size: 14px;
          cursor: pointer;
        }
      }

      .item_list_bottom {
        width: 100%;
        //height: 72px;
        display: flex;
        justify-content: flex-start;
        padding-left: 20px;
        line-height: 25px !important;
        padding-bottom: 8px;

        .flex {
          display: flex;
        }

        .bottom_left {
          min-width: 120px;
        }

        .first {
          display: flex;
          margin: 12px 20px 10px 0;

          .img {
            margin-top: 6px;
            width: 15px;
            height: 15px;
            margin-right: 3px;
          }

          .text {
            height: 20px;
            font-size: 13px;
            text-align: left;
          }
        }

        .second {
          height: 20px;
          font-size: 13px;
          text-align: left;
        }

        .center {
          margin-left: 58px;
          font-size: 13px;
          text-align: left;
          color: #101010;

          .center-first {
            margin-top: 10px;
          }
        }

        .right {
          flex: 0.88;
          line-height: 68px;
          font-size: 16px;
          text-align: right;
          color: #bcbcbc;
          display: flex;
          justify-content: flex-end;

          .right-btn {
            cursor: pointer;
            width: 80px;
            height: 21px;
          }
        }
      }
    }
  }
}

.no_data {
  background-color: #fff;
  color: grey;
  width: 100%;
  min-height: 120px;
  line-height: 120px;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  border-radius: 10px;
}

.form_style {
  margin: 10px 20px;
}

.edit_dialog {
  .el-select {
    width: 100%;
  }
}

.detail-dialog {
  text-align: left;

  ::v-deep .el-dialog {
    margin: 0 auto 15px;
    width: 70%;
  }

  ::v-deep .el-dialog__header {
    text-align: left;
    border-bottom: 0px;
    font-weight: normal;
  }

  ::v-deep .el-dialog__body {
    overflow: auto;
    max-height: 65vh;
    min-height: 30vh;
  }

  ::v-deep .el-dialog__footer {
    text-align: right;
    border: none;
  }

  .normal_btn {
    width: auto;
    border-radius: 5px;
    cursor: pointer;
  }

  .btn_bg_white {
    border: 1px solid rgb(204, 0, 0);
    color: rgb(204, 0, 0);
  }

  .btn_bg_red {
    color: white;
    background-color: rgb(204, 0, 0);
    border: 1px solid rgb(204, 0, 0);
  }
}
</style>
